import type { TopbarNotificationConfig } from '@eliadmin/core/src/components/header/topbar-notification-types';
import { AiFillWarning } from 'react-icons/ai';

export const TOPBAR_NOTIFICATION_CONFIG = {
  variant: 'viewport-marquee',
  renderer: 'html',
  icon: <AiFillWarning className="h-8 w-8 flex-shrink-0 sm:h-5 sm:w-5" aria-hidden="true" />,
  dismissible: true,
  dismissDurationMs: 2 * 24 * 60 * 60 * 1000,
  storageKey: 'ea-topbar-notification-dismissed',
  marqueeSpeed: 90,
  viewportItemWidth: 1280,
  viewportRepeatCount: 3,
  respectReducedMotion: false,
  className: {
    root: 'w-full bg-accent text-sm text-accent-foreground',
  },
} satisfies TopbarNotificationConfig;
